import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as LinkElm } from 'react-router-dom';
import { createSelector } from 'reselect';
import cx from 'classnames';

import { Urls } from 'constants/constants';

import Link, { selectLinks } from 'store/models/Link';

import Scrollbars from 'components/Scrollbars';
import { PlusIcon } from 'components/Svg';
import Button, { ButtonList, NewButton, SmallButton, TextButton } from 'components/Button';
import { ErrorList } from 'components/forms/Error';


// ===========================
// PARTIALS
// ===========================
const LinkLibraryItem = React.forwardRef(({ link, onLinkPreview, onLinkAdd, disabled, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cx("g-link-library-item", className, { disabled })}
    onClick={() => onLinkAdd?.(link?._id, link)}
    {...props}>
    <div className="link-info">
      <div className="link-name">{ link?.name }</div>
      <div className="link-url">{link?.url}</div>
    </div>
    <ButtonList>
      <SmallButton onClick={() => onLinkAdd(link?._id, link)}>+ Add</SmallButton>
    </ButtonList> 
  </div>
))


// ===========================
// COMPONENT
// ===========================
export const LinkLibrary = ({ hideIds, disableIds, onLinkAdd, onLinkPreview, onLinkCreate, className,...props}) => {
  let links = useSelector(state => selectLinks(state)) 
    |> _.filter(#, link => !_.includes(hideIds, link?._id));
  let dispatch = useDispatch();
  let onMount = useEffect(() => {
    dispatch(Link.actions.fetchLinks());
  }, []);
  const onCreateLinkClick = () => onLinkCreate?.()

  return (
    <div className={cx("g-link-library", className)}>
      <div className="actions">
        <NewButton size="s" onClick={onCreateLinkClick}>Create Link</NewButton>
        <TextButton href={Urls.LINKS}>Manage Links</TextButton>
      </div>
      <Scrollbars>
        <div className="link-item-list">
          {_.map(links, link => (
            <LinkLibraryItem 
              key={link?._id}
              link={link}
              disabled={_.includes(disableIds, link._id)}
              onLinkAdd={onLinkAdd}
              onLinkPreview={onLinkPreview} />
          ))}
        </div>
      </Scrollbars>
    </div>);
}

export default LinkLibrary